import React, { useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { deviceDetect } from 'react-device-detect'
import { getPatMedicalHistory } from './api/api'
import patMedHistReducer from './utils/reducer'
import { message } from 'antd'
import MobMedicalHistory from './Mobile/components/MobMedicalHistory'
import DesktopMedicalHistory from './desktop/components/DesktopMedicalHistory'
import { handleError } from '../../lib/utils'

const PatMedHist = () => {
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const initializeData = async () => {
      setLoading(true)
      const startTime = Date.now()

      try {
        const data = await getPatMedicalHistory()
        dispatch(patMedHistReducer.actions.setState(data))
      } catch (error) {
        message.error(handleError(error, true))
      }

      // Ensure loading screen shows for at least 2 seconds
      const elapsedTime = Date.now() - startTime
      const minimumLoadingTime = 2000 // 2 seconds
      const remainingTime = minimumLoadingTime - elapsedTime

      if (remainingTime > 0) {
        setTimeout(() => {
          setLoading(false)
        }, remainingTime)
      } else {
        setLoading(false)
      }
    }
    initializeData()
    // eslint-disable-next-line
  }, [])

  // Device detection - render appropriate version
  if (deviceDetect().isMobile) {
    return <MobMedicalHistory loading={loading} />
  }

  // Desktop version
  return <DesktopMedicalHistory loading={loading} />
}

export default PatMedHist
